import { ViewController, GalleryView, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { GroupTablesView } from "../../View/GroupTablesView";
import { Competition } from "../../Data/Competition";

export class GroupTablesGalleryViewController extends ViewController {
    galleryView:GalleryView;

    /**
     * flag to show if pageIndex has already been set
     */
    set:boolean;

    /**
     *
     */
    pairOfGroupsToBeHighlighted:number;
    leagueStageChunkInfos: any;
    leagueStageGroupInfos: any;
    numberOfClubChunkGroups: number; // one chunk group could be more than one group (e.g. one group is Group A&B)

    constructor(options) {
        options = options || {};
        options.name = options.name || 'groupTablesGalleryViewController';
        options.view = options.galleryView || null;

        super(options);

        this.set = false;
        this.pairOfGroupsToBeHighlighted = 0;
        this.galleryView = options.galleryView || null;
        this.galleryView.galleryPageContainerView.numberOfItemsToShow=srvg.widgets.overlaySettings.numberOfGroupsOnOverlayPerSlide;
        this.galleryView.nextButtonView.setDelegate(this);
        this.galleryView.prevButtonView.setDelegate(this);

        app.timelineController.addSubscriberForEvent(this, ChunkChangeEvent);
        app.timelineController.addSubscriberForEvent(this, ChunkRangeChangeEvent);

        this.leagueStageChunkInfos = {};
        this.leagueStageGroupInfos = {};
        this.numberOfClubChunkGroups = 0;

        for (var chunkid in srvg.chunks ){
            if (srvg.chunks.hasOwnProperty(chunkid) && srvg.chunks[chunkid].competitionstage_type_id === 1) { // only for league stage
                if (typeof this.leagueStageGroupInfos[srvg.chunks[chunkid].chunk_subtitle] === "undefined") {
                    this.leagueStageGroupInfos[srvg.chunks[chunkid].chunk_subtitle] = {
                        name: srvg.chunks[chunkid].chunk_subtitle,
                        numberof: 0,
                        groupNumber: this.numberOfClubChunkGroups
                    };
                    this.numberOfClubChunkGroups++;
                }
                this.leagueStageGroupInfos[srvg.chunks[chunkid].chunk_subtitle].numberof++;

                this.leagueStageChunkInfos[chunkid] = {
                    chunkid: chunkid,
                    chunk: srvg.chunks[chunkid],
                    groupNumber: this.leagueStageGroupInfos[srvg.chunks[chunkid].chunk_subtitle].groupNumber
                };
            }
        }
    }

    // ************************** Event handlers **************************

    handleButtonClickEvent(event:ButtonClickEvent, provider) {
        if (this.galleryView.galleryPageContainerView.animatingSubViewsCount) {
            // This guard prevents the pager view from misbehaving
            return;
        }
        var pageIndex = null;
        if (event.button == this.galleryView.prevButtonView) {
            pageIndex = this.galleryView.galleryPageContainerView.showPrev();
        }
        else if (event.button == this.galleryView.nextButtonView) {
            pageIndex = this.galleryView.galleryPageContainerView.showNext();
        }

        if (this.galleryView.pagerView) {
            this.galleryView.pagerView.selectIndex(pageIndex);
        }
    }

    handleChunkRangeChangeEvent(event:ChunkRangeChangeEvent, provider) {
        if (!this.galleryView.galleryPageContainerView.subViews.length ) {
            var chunkRange = event.chunkRange;

            // setup gallery
            if (chunkRange.length) {
                var competition:Competition = <Competition>chunkRange[0].competition;
                for (var groupNr = 0; groupNr < competition.numberOfGroups; groupNr++) {
                    var groupTablesView = this.galleryView.addGalleryItem(new GroupTablesView({
                        template: app.templateEngine.template(GroupTablesView),
                        groupNr: groupNr
                    }));
                }
                this.galleryView.updatePagerItems();
            }

            // chunkRangeChangeEvent is called on initial start, subviews are not ready when ChunkChangeEvent
            // is called, therefore we need to highlight here additionally
            this.highlightGroupPair(event);
        }
    }

    // when a ChunkChangeEvent is catched we have to mark the pair of groups that has currently running matches
    handleChunkChangeEvent(event:ChunkChangeEvent, provider) {
        this.highlightGroupPair(event);
    }

    highlightGroupPair(event) {
        if (srvg.product.mode != "VFLM" && srvg.product.mode != "VFB") {
            // gallery view container
            var gallery = this.galleryView.galleryPageContainerView;
            // current stage name
            var stage = null;
            // chunk number
            var chunkNr = null;

            // depending on the event we need to fetch data from a chunkRange or chunk
            if (event.chunkRange) {
                stage = event.chunkRange[0].competitionStageType;
                chunkNr = event.chunkRange[0].nr;
            } else {
                stage = event.chunk.competitionStageType;
                chunkNr = event.chunk.nr;
            }
            // if there is at least one subview
            if (gallery.subViews[0]) {
                // only necessary if in league mode
                if (stage == "league") {

                    var subViewContainingGroupPairs = null;

                    this.pairOfGroupsToBeHighlighted = this.leagueStageChunkInfos[chunkNr].groupNumber;

                    // adjust index if necessary
                    if(!srvg.widgets.overlaySettings.highlightGroups) {
                        this.pairOfGroupsToBeHighlighted *= 2;
                    }

                    var that = this;
                    // the subView has three subviews containing group pairs A&B, C&D and E&F
                    for (var i = 0; i < this.numberOfClubChunkGroups; i++) {
                        // those subViews have two subviews themselves containing the single group
                        subViewContainingGroupPairs = srvg.widgets.overlaySettings.highlightGroups?
                            gallery.subViews[i]: gallery.subViews[i*2];

                        // set red border and slightly increase height to both elements of the designated pair
                        if (i == this.pairOfGroupsToBeHighlighted  && srvg.widgets.overlaySettings.highlightGroups) {
                            $(subViewContainingGroupPairs.subViews[0].selector).addClass('marked');
                            $(subViewContainingGroupPairs.subViews[1].selector).addClass('marked');
                        }
                        // reset changes of the other subViews
                        else {
                            this.resetGroupPair(gallery.subViews[i]);
                        }
                    }
                    if( srvg.product.instanceType == 'Shop' ) {
                        this.galleryView.galleryPageContainerView.showSpecific(this.pairOfGroupsToBeHighlighted);
                    }
                }
                else {
                    // in ko-stage always show first two groups
                    this.pairOfGroupsToBeHighlighted = 0;
                    this.galleryView.galleryPageContainerView.showSpecific(this.pairOfGroupsToBeHighlighted);

                    // reset all subViews as not in league mode
                    for (var j = 0; j < this.numberOfClubChunkGroups; j++) {
                        this.resetGroupPair(gallery.subViews[j]);
                    }
                }
            }
        }
    }

    // resets highlighting of subViews of a given domNode element
    resetGroupPair(subViewContainingGroupPairs) {
        if ((srvg.product.mode != "VFLM" && srvg.product.mode != "VFB") && srvg.widgets.overlaySettings.highlightGroups) {
            $(subViewContainingGroupPairs.subViews[0].selector).removeClass('marked');
            $(subViewContainingGroupPairs.subViews[1].selector).removeClass('marked');
        }
    }
}
